<template>
  <v-container text-sm-center>
    <v-row color="primary" align="center" justify="center">
      <v-col md="11" sm="11" lg="9">
        <v-card color="primary">
          <v-row align="center" justify="center">
            <v-col>
              <v-card-text>
                <h1 class="text-center white--text">
                  BEM-VINDOS AO DIAGNÓSTICO
                </h1>
              </v-card-text>
            </v-col>
          </v-row>

          <v-row align="center" justify="center">
            <v-col align="center" justify="center">
              <v-img
                justify="center"
                :src="'/assets/img/' + logo"
                width="40%"
                v-if="
                  isFullAdmin ||
                  (groupsConfig.visualizarLogo && config.visualizarLogo)
                "
              >
              </v-img>
            </v-col>
          </v-row>

          <v-row align="center" justify="center" v-if="!isSala">
            <v-col align="center" justify="center">
              <img
                justify="center"
                src="/assets/img/diagnostico/1.png"
                width="40%"
              />
            </v-col>

            <v-col align="center" justify="center">
              <img
                justify="center"
                src="/assets/img/diagnostico/2.png"
                width="40%"
              />
            </v-col>

            <v-col align="center" justify="center">
              <img
                justify="center"
                src="/assets/img/diagnostico/3.png"
                width="40%"
              />
            </v-col>
          </v-row>

          <v-row v-if="!isSala">
            <v-col align="center" justify="center">
              <img
                justify="center"
                src="/assets/img/diagnostico/perguntas.png"
                width="40%"
              />
            </v-col>

            <v-col align="center" justify="center">
              <img
                justify="center"
                src="/assets/img/diagnostico/evolucao cidade.png"
                width="40%"
              />
            </v-col>

            <v-col align="center" justify="center">
              <img
                justify="center"
                src="/assets/img/diagnostico/avaliacao.png"
                width="40%"
              />
            </v-col>
          </v-row>

          <v-row>
            <v-col>
              <v-btn
                color="azulclarosc white--text"
                class="ml-3"
                @click="createDiagnostic()"
              >
                Iniciar Diagnóstico
              </v-btn>
            </v-col>
          </v-row>
        </v-card>
      </v-col>
    </v-row>
    <!--
    <v-row
      color="primary"
      align="center"
      justify="center"
      v-else
    >
      <v-col
        md="11"
        sm="11"
        lg="9"
      >
        <v-card
          color="primary"
        >
          <v-row
            align="center"
            justify="center"
          >
            <v-col>
              <v-card-text>
                <h2
                  class="text-center white--text"
                >
                  BEM-VINDOS AO DIAGNÓSTICO
                </h2>
              </v-card-text>
            </v-col>
          </v-row>

          <v-row
            align="center"
            justify="center"
          >
            <v-col
              align="center"
              justify="center"
            >
              <v-img
                justify="center"
                src="/assets/img/diagnostico-apresentacao.png"
                width="50%"
              >
              </v-img>
            </v-col>
          </v-row>

          <v-row>
            <v-col>
              <v-btn
                color="warning"
                class="ml-3"
                @click="createDiagnostic()"
              >
                Iniciar Diagnóstico
              </v-btn>
            </v-col>
          </v-row>
        </v-card>
      </v-col>
    </v-row>
  -->
  </v-container>
</template>

<script>
import { diagnosticAPI } from "./DiagnosticAPI";
import { mapGetters, mapActions } from "vuex";

export default {
  computed: {
    ...mapGetters(["user", "isSala", "isFullAdmin"]),
  },
  mounted() {
    document.getElementsByClassName("v-content__wrap")[0].style.background =
      'url("/assets/img/bg-diagnostico.jpg") no-repeat ';
    document.getElementsByClassName("v-content__wrap")[0].style.backgroundSize =
      "cover";
  },
  data() {
    return {
      acompanhamento: {
        nome: "Diagnóstico",
        municipioId: parseInt(this.$route.params.id),
        usuarioId: 1,
      },
      config: JSON.parse(localStorage.getItem("config")),
      userTeste: JSON.parse(localStorage.getItem("user")),
      groupsConfig: JSON.parse(localStorage.getItem("groupsConfig")),
      estado: this.$store.state.uf,
      logo: this.$store.state.logo,
    };
  },
  methods: {
    ...mapActions(["setLoading"]),
    createDiagnostic() {
      this.setLoading(true);
      diagnosticAPI
        .createDiagnostic(this.acompanhamento)
        .then((resp) => {
          this.setLoading(false);
          this.$router.push(
            "/diagnostico/" + this.acompanhamento.municipioId + "/tema"
          );
        })
        .catch((resp) => {
          this.setLoading(false);
          this.$notification.error("Erro ao criar diagnóstico");
        });
    },
  },
};
</script>

<style lang="scss">
@import "./style.scss";
</style>
